export default "__VITE_ASSET__fdeae6a7__"